/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 东艺首页广告信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  type: "SHOW_SET" | "VIDEO_SET" | "NEAR_EVENT" | "WECHAT_MALL",

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<cms.DongYiAdvertDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/theater/dongyi-adverts/${type}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
